/**
 * @fileoverview イベント用カードコンポーネントの汎用的な列レイアウトコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { cardCommonProps } from '@/components/_parials/contentsCard'
import EventCard from '@/components/events/EventCard.vue'

export default defineComponent({
  name: 'LayoutEventCardsCols',

  components: {
    EventCard,
  },

  props: {
    ...cardCommonProps,

    /**
     * コンテンツ情報の配列
     */
    items: {
      type: Array as PropType<SolutionEventItem[]>,
      required: true,
    },

    /**
     * 表示する列数
     * 指定範囲: 1 〜 6
     */
    cols: {
      type: Object as PropType<{
        pc: 1 | 2 | 3 | 4 | 5 | 6,
        sp: 1 | 2 | 3 | 4 | 5 | 6,
      }>,
      default: () => ({
        pc: 3,
        sp: 1,
      }),
      validator(value: { pc: number, sp: number }) {
        // 1 〜 6 の整数値が指定されてるかどうか
        const pc = [...Array(6)].map((_, i) => i + 1).includes(value.pc)
        const sp = [...Array(6)].map((_, i) => i + 1).includes(value.sp)
        return pc && sp
      },
    },

    /**
     * PC でも横向きタイプ表示にするフラグ
     * @description 重複定義の場合は full の設定が優先される
     */
    horizontal: {
      type: Object as PropType<{ pc: boolean, sp: boolean }>,
      default: () => ({
        pc: false,
        sp: true,
      }),
    },
  },
})
</script>

<template>
  <div
    v-if="items.length"
    class="o-list__eventCard"
    :data-cols-pc="cols.pc"
    :data-cols-sp="cols.sp">
    <ul class="o-list__eventCard--items">
      <li
        v-for="(item) in items"
        :key="item.id"
        class="o-list__eventCard--item">
        <EventCard
          :item="item"
          :has-hero="hasHero"
          :highlight-word="highlightWord"
          :size="size"
          :horizontal="horizontal"
          :heading-options="headingOptions"
          :image-options="imageOptions" />
      </li>
    </ul>
  <!-- /.o-list__eventCard --></div>
</template>

<style lang="sass" scoped>
.o-list__eventCard
  $root: &
  $margin-px: 24
  margin: 1em auto 0

  &:first-child
    margin-top: 0

  & &--items
    display: flex
    flex-wrap: wrap

  & &--item
    margin-top: changeSizePx2Em($margin-px)

  // Phablet 以上のとき
  +breakpoint($max: false, $min: true)
    @for $i from 1 through 6
      &[data-cols-pc="#{$i}"]
        $col-width: math.div(($global-contents-width-pc - $margin-px * ($i - 1)), $i)
        > #{$root}--items
          > #{$root}--item
            width: getRelativeValue($col-width, $global-contents-width-pc)
            margin-left: getRelativeValue($margin-px, $global-contents-width-pc)

            &:nth-child(-n+#{$i})
              margin-top: 0

            &:nth-child(#{$i}n+1)
              margin-left: 0

  // Phablet 未満のとき
  +breakpoint
    display: block

    #{$root}--item
      margin-top: changeSizePx2Em(12)
      padding-top: changeSizePx2Em(12)
      border-top: 1px solid $border-x-light-gray

    $margin-px: 12
    @for $i from 1 through 6
      &[data-cols-sp="#{$i}"]
        $col-width: math.div(($global-contents-width-pc - $margin-px * ($i - 1)), $i)
        > #{$root}--items
          > #{$root}--item
            width: getRelativeValue($col-width, $global-contents-width-pc)
            margin-left: getRelativeValue($margin-px, $global-contents-width-pc)

            &:nth-child(-n+#{$i})
              margin-top: 0
              padding-top: 0
              border-top: none

            &:nth-child(#{$i}n+1)
              margin-left: 0
</style>
